import { AlertCircle, Loader2 } from "lucide-react";
import type { PersonaState } from "../model/types";

interface PersonaStatusIconProps {
  state: PersonaState;
  className?: string;
}

/** Generation state as a glyph. Renders nothing when the persona is ready —
 *  a ready persona is the normal case and should carry no decoration. */
export function PersonaStatusIcon({ state, className = "w-3 h-3" }: PersonaStatusIconProps) {
  if (state === "generating") {
    return <Loader2 className={`${className} animate-spin shrink-0`} aria-label="Generating" />;
  }
  if (state === "failed") {
    return <AlertCircle className={`${className} shrink-0 text-red-500`} aria-label="Some reports failed" />;
  }
  return null;
}
